import imageRecording from 'assets/recording.svg';
import { StatusMessages } from 'components/Tool/ReactMediaRecorder/ReactMediaRecorder';
import { useEffect } from 'react';
import { useCountUp } from 'utils/useCountUp';
import { formatTime } from 'utils/utils';
import './RecordingRecorder.css';

function RecordingRecorder({
  status,
  maxTime,
  onTimeEnds
}: {
  status: StatusMessages;
  maxTime: number;
  onTimeEnds: () => void;
}) {
  const { timerCountUp, pauseCountUp, resumeCountUp } = useCountUp();

  useEffect(() => {
    if (status === 'recording') {
      resumeCountUp();
    } else if (status === 'paused') {
      pauseCountUp();
    }
  }, [pauseCountUp, resumeCountUp, status]);

  useEffect(() => {
    if (timerCountUp >= maxTime) {
      onTimeEnds();
    }
  }, [maxTime, onTimeEnds, timerCountUp]);

  const label = status === 'recording' ? 'Recording' : status === 'paused' ? 'Paused' : 'Ready';

  return (
    <div className="recording-recorder">
      <div>
        <img src={imageRecording} alt="" className="icon" /> {label}
      </div>
      <div className="recording-time">Time: {formatTime(timerCountUp)}</div>
      <div className="recording-time">Remaining: {formatTime(maxTime - timerCountUp)}</div>
    </div>
  );
}

export default RecordingRecorder;
